// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFooter_root__2wlbI"};